import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'

import { useFetchInitialState } from '../../hooks/useFetchInitialState'

import * as initialStateModule from '../../reducks/initialState'
import { initialiseDashboardState } from '../../../Dashboard/redux/modules/dashboard'
import { initialiseCandidate } from '../../../Onboarding/redux/modules/candidate'

import LoadingScene from '../../scenes/LoadingScene'
import ErrorScene from '../../scenes/ErrorScene'

const PopulateInitialState = ({ children, setInitialReduxState, candidateProfileId, candidate }) => {
  const { status: stateFetchStatus } = useFetchInitialState({
    candidateProfileId,
    setInitialReduxState,
  })

  if (stateFetchStatus === 'error') return <ErrorScene />

  // check if the initial state is populated in the Redux state to avoid errors where loading is finished but Redux state is not yet set
  const isReduxStorePopulated = candidateProfileId ? !isEmpty(candidate) : true
  if (stateFetchStatus === 'loading' || !isReduxStorePopulated) return <LoadingScene />

  return children
}

PopulateInitialState.propTypes = {
  children: PropTypes.node,
  setInitialReduxState: PropTypes.func,
  candidateProfileId: PropTypes.string,
  candidate: PropTypes.shape({}),
}

const mapStateToProps = state => ({
  candidate: state.candidate,
})

const mapDispatchToProps = dispatch => ({
  setInitialReduxState: state => {
    dispatch(initialStateModule.initialiseStaticData(state.static_data))
    dispatch(initialiseCandidate(state.candidate))
    dispatch(initialiseDashboardState(state.dashboard_state))
  },
  setCurrentUser: currentUser => dispatch(initialStateModule.initialiseCurrentUser(currentUser)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PopulateInitialState)
